import Messenger from '@/Utility/Messenger';
import Class from '@/Class';

declare let moment: moment.MomentStatic;

export default class Profiler {
    private from;
    private until;
    private SHOW_DISPOSE;
    private logs: KnockoutObservableArray<any>;

    constructor() {
        this.from = null;
        this.until = null;
        this.SHOW_DISPOSE = false;
        this.logs = ko.observableArray([]);

        Messenger.registerForMessageId('NavigationStartedMessage', (message: any) => { this.writeLog({ message: 'NAVIGATING: ' + message.address.toString() }, { highlight: true }); }, this);
        Messenger.registerForMessageId('ViewFactoryLoadingMessage', (message: any) => { this.writeLog({ message: 'LOADING: ' + message.name }, { highlight: true }); }, this);
        Messenger.registerForMessageId('RegionCleaningMessage', (message: any) => { this.writeLog({ message: 'CLEANING: ' + message.name }, { highlight: true }); }, this);
    }

    public writeLog(entry, params?) {
        entry.date = moment();

        if (!params || params.showTime !== false) {
            entry.message = entry.date.format('hh:mm:ss:SSSS') + ': ' + entry.message;
        }

        if (params && params.highlight !== false) {
            entry.message = '<strong>' + entry.message + '</strong>';
        }

        if (params && params.light === true) {
            entry.message = '<span style="color: #ccc; font-size: 8pt;">' + entry.message + '</span>';
        }

        this.logs.push(entry);
    }

    public removeLog(entry) {
        let logs = this.logs();

        for (let i = 0; i < logs.length; i++) {
            if (logs[i].message.indexOf(entry.message) > -1) {
                this.logs.splice(i, 1);
                break;
            }
        }
    }

    public onInstanceCreated(instance: Class) {
        let now = moment();
        let diff;

        if (this.from != null && now != null) {
            diff = now.diff(this.from);
        }

        this.from = now;

        let color = diff >= 20 ? (diff >= 100 ? 'red' : 'orange') : 'black';
        let weight = color === 'red' || color === 'orange' ? 'bold' : 'normal';
        let diffText = '<span style="color: ' + color + '; font-weight: ' + weight + '">[' + diff + 'ms]</span> ';

        this.writeLog({
            message: diffText + instance.identifier,
            onClick: () => {
                console.log(instance);
            }
        });
    }

    public onInstanceDisposed(instance: Class) {
        this.removeLog({ message: instance.identifier });

        if (this.SHOW_DISPOSE === true) {
            this.writeLog({ message: 'DISPOSING: ' + instance.identifier }, { light: true, highlight: false });
        }
    }
}